export default __webpack_public_path__ + "static/media/registrationcomplete.138a77e8.png";